import { render, staticRenderFns } from "./OrderMailer.vue?vue&type=template&id=7167873e&"
import script from "./OrderMailer.vue?vue&type=script&lang=js&"
export * from "./OrderMailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports